import { scrubUrl } from './datadog.utils';
import type { BrowserOptions } from '@sentry/react';

/**
 * Sentry options for the app. Page and request URLs can carry an OAuth code, an invite token or an email, so
 * event and breadcrumb URLs go through the same redaction as Datadog.
 */
export const sentryOptions: BrowserOptions = {
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  sendDefaultPii: true,
  beforeSend: (event) => {
    if (event.request?.url) event.request.url = scrubUrl(event.request.url);
    // The referrer is the full /signin URL after the post-sign-in page load.
    const referer = event.request?.headers?.Referer;
    if (referer) event.request!.headers!.Referer = scrubUrl(referer)!;
    return event;
  },
  beforeBreadcrumb: (breadcrumb) => {
    for (const key of ['url', 'from', 'to']) {
      const value = breadcrumb.data?.[key];
      if (typeof value === 'string') breadcrumb.data![key] = scrubUrl(value);
    }
    return breadcrumb;
  },
};
